import ErrorDashboardService from '@/api/admin/errorDashboard.service'

export default {
  state: {
    table: {
      rows: [],
      searchTerm: '',
    },
    dateRange: '',
  },
  getters: {
    allErrors: state => state.table,
    getDateRange: state => state.dateRange,
  },
  actions: {
    async getErrors({ commit }, dateRange) {
      const errors = await ErrorDashboardService.getErrors(dateRange)
      commit('SET_ERRORS', errors)
      commit('SET_DATE_RANGE', errors.dateRange)
    },
  },
  mutations: {
    SET_ERRORS(state, errors) {
      state.table.rows = errors.imaErrors
    },
    SET_DATE_RANGE(state, dateRange) {
      state.dateRange = dateRange
    },
  },
}
